import ApiKeyAdmin from "../Components/ApiKeys/ApiKeyAdmin";

const ApiKeys = () => {
  return <ApiKeyAdmin />;
};

export default ApiKeys;
